export default {
  lpbDashboard: {
    filterPanel: {
      containerPadding: '0 16px',
      linksAligment: 'flex-start',
    },
    tile: {
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
      boxShadowHover: '0 8px 16px 0 rgba(0, 0, 0, 0.1), 0 1px 3px 0 rgba(0, 0, 0, 0.1)',
    },
    colors: {
      bg: '#f0f0f0',
      tileOverlayBg: '#4c93e680',
      tileOverlayLink: '#3b73b3',
      tileAbbrText: '#1f40e6',
      filterBg: '#fff',
      filterLinkActive: '#2251ff',
      filterBorder: '#e6e6e6',
      filterLinkColor: '#333',
      filterArrowsBg: '#fff',
      filterArrowColor: '#ccc',
      fallbackMsgColor: '#999',
      pageNotFoundBg: '#f0f0f0',
      tileArrowsBg: '#fff',
      tileLinkBg: '#fff',
      tileImgBoxBg: '#fff',
      tileImgBoxBorder: '#e4ecf5',
      tileTitleColor: '#333',
      tileDescriptionColor: '#7f7f7f',
    },
  },
  colors: {
    appFrame: {
      breadcrumbs: {
        containerBg: '#f0f0f0',
      },
    },
  },
};
